import { get, httpDelete, patch, post, put } from '../../utils/http';

export const fetchHelpDeskAccountSettings = ({ accountId }) => get(`/accounts/${accountId}/help-desk/settings`);

export const updateHelpDeskAccountSettings = ({ accountId, ...body }) =>
  put(`/accounts/${accountId}/help-desk/settings`, body);

/** Categories for one or more branches. Returns { data: { [branchId]: Category[] } }. */
export const fetchHelpDeskCategoriesForBranches = ({ accountId, branchIds, includeDeleted, onlyMyCategories }) => {
  if (!Array.isArray(branchIds) || !branchIds.length) return Promise.resolve({ data: {} });
  return get(`/accounts/${accountId}/help-desk/categories`, {
    branchIds,
    ...(includeDeleted === true && { includeDeleted: true }),
    ...(onlyMyCategories === true && { onlyMyCategories: true })
  });
};

export const createHelpDeskCategory = ({ accountId, branchId, ...body }) =>
  post(`/accounts/${accountId}/branches/${branchId}/help-desk/categories`, body);

export const updateHelpDeskCategory = ({ accountId, branchId, categoryId, ...body }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/help-desk/categories/${categoryId}`, body);

export const deleteHelpDeskCategory = ({ accountId, branchId, categoryId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/help-desk/categories/${categoryId}`);

export const fetchHelpDeskTickets = ({ accountId, ...query }) => get(`/accounts/${accountId}/help-desk/tickets`, query);

export const fetchHelpDeskTicket = ({ accountId, ticketId }) =>
  get(`/accounts/${accountId}/help-desk/tickets/${ticketId}`);

export const updateHelpDeskTicket = ({ accountId, ticketId, ...body }) =>
  patch(`/accounts/${accountId}/help-desk/tickets/${ticketId}`, body);

export const fetchHelpDeskMessages = ({ accountId, ticketId, ...query }) =>
  get(`/accounts/${accountId}/help-desk/tickets/${ticketId}/messages`, query);

export const sendHelpDeskMessage = ({ accountId, ticketId, ...body }) =>
  post(`/accounts/${accountId}/help-desk/tickets/${ticketId}/messages`, body);

export const fetchHelpDeskAdmins = ({ accountId, branchId, categoryId }) =>
  get(`/accounts/${accountId}/help-desk/admins`, {
    ...(branchId && { branchId }),
    ...(categoryId && { categoryId })
  });

export const getHelpDeskAttachmentUrl = ({ accountId, ticketId, attachmentId }) =>
  get(`/accounts/${accountId}/help-desk/tickets/${ticketId}/attachments/${attachmentId}/url`);

export const uploadHelpDeskFile = ({ accountId, formData }) =>
  post(`/accounts/${accountId}/help-desk/upload`, formData);

export const fetchEmployeeHelpDeskTickets = ({ accountId, employeeId, ...query }) =>
  get(`/accounts/${accountId}/help-desk/employees/${employeeId}/tickets`, query);

export const fetchHelpDeskUnreadCount = ({ accountId }) => get(`/accounts/${accountId}/help-desk/tickets/unread-count`);

export const createHelpDeskTicket = ({ accountId, ...body }) => post(`/accounts/${accountId}/help-desk/tickets`, body);
